import SearchIcon from "@assets/search.svg";
import styled from "@emotion/styled";

export const SearchInputLabel = styled.label`
  display: flex;
  align-items: center;
  opacity: 1;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 6px;
  color: ${({ theme }) => theme.colours.accent.dark._20};
  font-size: 10px;
  font-weight: 600;
  font-style: SemiBold;
  letter-spacing: 0px;
  text-align: left;
  line-height: 16px;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 12px 0;
  box-shadow:
    0px 0px 0px 0.5px ${({ theme }) => theme.colours.accent.light._20} inset,
    0px -17px 10px -1px rgba(237, 236, 229, 1) inset;
  opacity: 1;
  background-color: ${({ theme }) => theme.colours.accent.light._20};
`;

export const SearchInput = styled.input`
  border-radius: 6px;
  padding: 13px 12px 16px 40px;
  background: url("${SearchIcon}") no-repeat 12px center;
  background-size: 20px;
  border: 1px solid rgba(199, 196, 183, 1);
  box-shadow:
    0px -2px 3px ${({ theme }) => theme.colours.accent.light._20} inset,
    0px 1px 3px 1px rgba(253, 253, 251, 1) inset,
    0px 2px 4px rgba(9, 9, 11, 0.08);
  opacity: 1;
  background-color: ${({ theme }) => theme.colours.accent.light._10};
  height: 48px;

  ::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.colours.accent.mid.dark20};
    font-size: 14px;
    font-weight: 600;
    font-style: SemiBold;
    letter-spacing: 0px;
    text-align: left;
    line-height: 22px;
  }
`;
